module.exports = __webpack_public_path__ + "static/media/manual_de_vendas_wdental.a1059a29.pdf";